export const APP_STORE_URL =
  "https://apps.apple.com/es/app/soldi-control-gastos-finanzas/id6739777905";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.soldi.soldiapp";
